module.exports = __webpack_public_path__ + "img/footer-logo.2f52a59c.svg";